<div class="spinner-border" role="status" [class.small]="size == 'small'" [class.medium]="size == 'medium'" [class.color-white]="color=='white'">
  <span class="sr-only">Loading...</span>
</div>